<template>
  <div>
    <v-alert
      type="warning"
      colored-border
      border="right"
      icon="mdi-alert-outline"
    >
      <div class="mb-6 d-flex">
        <span>
          {{ $t('errors.default') }}
        </span>
        <span class="ml-auto mr-2">
          {{ $t('errors.errorCode', { code }) }}
        </span>
      </div>

      <div v-if="code === 'network_error' || code === 'api500'">
        Der har været et problem med serveren. Klik på knappen "Genindlæs" for at prøve igen. Hvis problemet stadig er der, så kontakt supporten.
      </div>
      <div v-if="code === 'api404'">
        {{ $t('errors.pageNotFound') }}
      </div>
      <div v-else-if="code === 'invalid_tenant'">
        <div class="mb-4">
          {{ $t('errors.invalidTenant', { email: $route.query.email ?? 'unknown', tenantId: $route.query.tenantId ?? 'unknown' }) }}
        </div>
        <div class="d-flex align-center" style="gap: 1rem;">
          <v-btn :disabled="hasAlreadyRequestedAccess || !account?.localAccountId" :loading="requesting" @click="requestAccess">
            Request access
          </v-btn>
          <v-fade-transition>
            <div v-if="hasAlreadyRequestedAccess">
              {{ $t('errors.alreadyRequestedAccess') }}
            </div>
          </v-fade-transition>
        </div>
      </div>
      <div v-else-if="code === 'accessdenied_invalidclient' || code === 'accessdenied_invalidresource' || code === 'clientautherror_statemismatch'">
        <p>{{ $t('errors.accessDenied') }}</p>
        <p>Måske er du logget på med en anden Microsoft konto<span v-if="account && account.username"> ({{ account.username }})</span>, end den der er registeret hos os.</p>
        <p>Når du bliver spurgt om login, skal du måske prøve at vælge en "anden konto".</p>
        <p>Klik på knappen for at logge ind igen eller du kan kontakte din administrator eller TPA Support.</p>
      </div>
      <div v-else-if="code === 'user_not_found' || code === 'UserNotFound'">
        <div class="mb-4">
          {{ $t('errors.userNotFound') }}
        </div>

        <div class="d-flex align-center" style="gap: 1rem;">
          <v-btn :disabled="hasAlreadyRequestedAccess || !account?.localAccountId" :loading="requesting" @click="requestAccess">
            Request access
          </v-btn>
          <v-fade-transition>
            <div v-if="hasAlreadyRequestedAccess">
              {{ $t('errors.alreadyRequestedAccess') }}
            </div>
          </v-fade-transition>
        </div>
      </div>
      <div v-else-if="code === 'UserFoundAccessDenied'">
        <p>
          Du har forsøgt at tilgå et modul i TPA Portalen du ikke har adgang til.<br>
          Hvis det er meningen at du skal have denne adgang, bedes du kontakte din administrator eller TPA Support.
        </p>
        <p>Hvis du efter endt dialog har fået adgang, kan du prøve at tilgå informationen igen.</p>
      </div>
      <div v-else-if="code === 'NoClaims' || code.includes('IDW10204')">
        <h1>{{ $t('errors.accessDenied') }}</h1>
        <p> Det ser ud til at du er logget på med den korrekte Microsoft konto, men ikke har de rettigheder der skal til for at tilgå TPA Portalen. </p>
      </div>
      <div class="mt-6 mb-2 d-flex" style="gap: 1rem;">
        <v-btn
          color="primary"
          @click="login"
        >
          Login igen
        </v-btn>
        <v-btn @click="reload">
          Genindlæs
        </v-btn>
        <v-btn v-if="returnUrl" @click="retry">
          Prøv igen
        </v-btn>
      </div>
    </v-alert>
    <v-card>
      <v-card-text>
        TPA Support kan kontaktes på +45 44 99 99 98 og <a href="mailto:support@tpa-solutions.dk">support@tpa-solutions.dk</a><br>man-tors 8-17, fredag til 8-16
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { msalInstance } from '@/services/AuthService';

export default {
  name: "Error",
  data() {
    return {
      requesting: false,
      hasAlreadyRequestedAccess: false
    }
  },
  mounted() {
    if (this.code === 'UserNotFound' || this.code === 'invalid_tenant') {
      this.checkAccessRequest();
    }
  },
  computed: {
    account() {
      return msalInstance.getActiveAccount();
    },
    name() {
      return this?.account?.name ?? "Du";
    },
    code() {
      return this.$route.query.code;
    },
    returnUrl() {
      return this.$route.query.returnUrl;
    }
  },
  methods: {
    reload() {
      window.location.href = '/';
    },
    retry() {
      this.$router.push(this.returnUrl);
    },
    login: async function() {
      await msalInstance.clearCache();      
      await msalInstance.loginPopup({ prompt: 'select_account' });
      this.reload();
    },
    checkAccessRequest: async function() {
      try {
        const { data } = await this.$api.get('access-requests/check-active-request', {
          params: {
            federationReference: this.account?.localAccountId
          }
        })

        this.hasAlreadyRequestedAccess = data;
      } catch (error) {
        console.error(error);
      }
    },
    requestAccess: async function() {
      const { name, username, tenantId, localAccountId } = this.account;

      this.requesting = true;

      try {
        const { data } = await this.$api.post('access-requests', {
          name,
          email: username,
          tenantId,
          federationReference: localAccountId
        });

        if (!data.success) {
          throw data.errors[0] ?? 'Some error happened';
        }

        this.$notifier.showSuccess({ message: 'Access requested successfully' })
        this.hasAlreadyRequestedAccess = true;
      } catch (error) {
        this.$notifier.showError({});
      } finally {
        this.requesting = false;
      }
    }
  },
};
</script>